export const BatchTypes = {
  affiliate: 'Account::Affiliate'
}
